module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAAXNSR0IArs4c6QAAAExJREFUCB1j+P//vwYQTwfRDFCAIQYUsAfiN1AazoZpANNQyQ9AGoTtYZJMMAZeGqobqxUsQElloG53IDZnZGS8CzIJKGYOpJKB9BMAQbtXj098Z5AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon--close--white.png
// module id = s8U3
// module chunks = 1